import AccountCreationForm from './AccountCreationForm';

export default AccountCreationForm;